import { render, staticRenderFns } from "./LocalFileUploaderModalV2.vue?vue&type=template&id=226c5edc"
import script from "./LocalFileUploaderModalV2.vue?vue&type=script&lang=js"
export * from "./LocalFileUploaderModalV2.vue?vue&type=script&lang=js"
import style0 from "./LocalFileUploaderModalV2.vue?vue&type=style&index=0&id=226c5edc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports